<template>
  <div
    :style="{ 'color': customTextColorContent ? customTextColorContent : textColor,
      'font-size': `${fontSize}px`,
      'font-family': FontContent, 
      'text-transform': data.Style.ToUpperCase ? 'uppercase' : 'none' ,
      'text-align': data.Style.TextAlign,
      'padding': !isSimulation && isDesktop ? '15px 30px 15px 30px' : '10px 15px 10px 15px' 
    }"
  >
    {{ title }}
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      },
    },
    data: () => ({
      textColor: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      title () {
        return this.data.Title ? utils.getTranslation (this.data.Title, this.locale) : ''
      },
      fontSize () {
        return this.FontSizeContent + this.data.Style.SizeMult
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      }
    },
    watch: {
      'data.Style.TextColor': {
        handler: function (newValue) {
          this.textColor = newValue ? newValue : this.ColorContent
        },
        deep: true
      },
    },
    mounted () {
      this.textColor = this.data.Style.TextColor ? this.data.Style.TextColor : this.ColorContent
    }
  }
</script>
